const isItalistLegitimate = {
  description: () =>
    'Real. Legit. Not fake. However you want to call it, italist products are guaranteed to be 100% authentic.',
  title: () => 'Shop at italist | Is italist legitimate?',
};

export default isItalistLegitimate;
